import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from "react-redux";
import store from "./redux/store";
import axios from "axios";

axios.interceptors.response.use(
  (response) => {
    if (response.config && response.config.url) {
      const url = response.config.url.toLowerCase();
      if (
        url.includes("/login") ||
        url.includes("/signup") ||
        url.includes("/forgot-password") ||
        url.includes("/reset-password") ||
        url.includes("/organisations1")
      ) {
        return response;
      }
    }

    if (response.data && response.data.status === false) {
      const msg = response.data.message || "";
      const lowerMsg = msg.toLowerCase();
      if (
        lowerMsg.includes("subscription has expired") ||
        lowerMsg.includes("deactivated") ||
        lowerMsg.includes("renew your subscription") ||
        lowerMsg.includes("renew")
      ) {
        localStorage.clear();
        window.location.href = "/login";
        return new Promise(() => {});
      }
    }
    return response;
  },
  (error) => {
    if (error.config && error.config.url) {
      const url = error.config.url.toLowerCase();
      if (
        url.includes("/login") ||
        url.includes("/signup") ||
        url.includes("/forgot-password") ||
        url.includes("/reset-password") ||
        url.includes("/organisations1")
      ) {
        return Promise.reject(error);
      }
    }

    if (error.response && error.response.data) {
      const data = error.response.data;
      if (data.status === false) {
        const msg = data.message || "";
        const lowerMsg = msg.toLowerCase();
        if (
          lowerMsg.includes("subscription has expired") ||
          lowerMsg.includes("deactivated") ||
          lowerMsg.includes("renew your subscription") ||
          lowerMsg.includes("renew")
        ) {
          localStorage.clear();
          window.location.href = "/login";
          return new Promise(() => {});
        }
      }
    }
    return Promise.reject(error);
  }
);

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.info = () => { };
  console.debug = () => { };
  console.warn = () => { };
}


ReactDOM.hydrate(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);



// File Created By sourav on 01/05/2023